export default __webpack_public_path__ + "static/media/640x300_04.9f549046.jpg";